import { render, staticRenderFns } from "./myMistake.vue?vue&type=template&id=2f900e7e&scoped=true&"
import script from "./myMistake.vue?vue&type=script&lang=js&"
export * from "./myMistake.vue?vue&type=script&lang=js&"
import style0 from "./myMistake.vue?vue&type=style&index=0&id=2f900e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f900e7e",
  null
  
)

export default component.exports